import gql from 'graphql-tag';

const EVENT_DEFINITION_LIST_QUERY = gql`
  query EventDefinitionList {
    eventDefinitions(pageSize: 1000) {
      nodes {
        id
        name
      }
    }
  }
`;

export default EVENT_DEFINITION_LIST_QUERY;
